import { componentStyle } from '@/styling/util/component-style.ts';

export const messageStyle = componentStyle({
    // info
    infoBackground: '{ color.messageInfoBackground }',
    infoBorderColor: '{ color.messageInfoBackground }',
    infoColor: '{ primary.500 }',
});
